import React, {useState, useEffect} from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {confirmAlert} from 'react-confirm-alert';
import {useForm} from 'react-hook-form';
import useCategoriesHook from '../../../api/productCategories';
import { ViewCategories } from '../../../components/admin/product-categories/ViewCategories';
import { FormCategories } from '../../../components/admin/product-categories/FormCategories';
// import useMachinesHook from '../../../api/machines';
import {checkImageFiles} from '../../../utils/imageTools';
import {useTranslation} from "react-i18next";
import DefaultCategoriesIcon from "../../../media/vending-machine.svg";

import {
    Spinner,
    Pagination,
    Message,
    Confirm, Search,
} from '../../../components'
const ProductCategories = () => {
    const [page, setPage] = useState(1)
    const [id, setId] = useState(null)
    const [edit, setEdit] = useState(false)
    const [q, setQ] = useState('')
    const { t} = useTranslation(); // Use i18n instance to access current language

    const {
        getProductCategories,
        postCategory,
        updateCategory,
        deleteCategory
    } = useCategoriesHook({
        page,
        q,
    })

    // const {getMachines} = useMachinesHook({
    //     limit: 100000,
    //     page: 1,
    // })

    // const {data: dataMachines} = getMachines

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: {errors},
    } = useForm({
        defaultValues: {
        },
    })

    const {
        data,
        isLoading,
        isError,
        error,
        refetch
    } = getProductCategories

    const {
        // data: responseUpdate,
        isLoading: isLoadingUpdate,
        isError: isErrorUpdate,
        isSuccess: isSuccessUpdate,
        mutateAsync: mutateAsyncUpdate,
    } = updateCategory

    const {
        // data: responseDelete,
        isLoading: isLoadingDelete,
        mutateAsync: mutateAsyncDelete,
    } = deleteCategory

    const {
        // data: responsePost,
        isLoading: isLoadingPost,
        isSuccess: isSuccessPost,
        mutateAsync: mutateAsyncPost,
    } = postCategory

    const formCleanHandler = (force = false) => {
        if (force || isSuccessPost || isSuccessUpdate) {
            console.log('clean handler true');
            setEdit(false);
            reset();
            setFileInputs([]); // Also reset the file inputs state
            setImageThumbnails([]); // Also reset the image thumbnails
        }
    }


    const [imageThumbnails, setImageThumbnails] = useState([]);
    const [imagesPath, setImagesPath] = useState({});



    useEffect(() => {
        if (isSuccessPost || isSuccessUpdate){
            setEdit(false);
        }
    }, [isSuccessPost, isSuccessUpdate])

    useEffect(() => {
        if (q.trim() || page) {
            refetch();
        }
    }, [page, q, refetch]);


    const searchHandler = (e) => {
        e.preventDefault()
        refetch()
        setPage(1)
    }

    const deleteHandler = (id) => {
        confirmAlert(Confirm(() => mutateAsyncDelete(id)))
    }

    const [fileInputs, setFileInputs] = useState([]);


    const submitHandler = async (itemData) => {
        try {
            console.log('submitHandler');

            console.log(fileInputs);

            if (edit) {

                const allImages = checkImageFiles(fileInputs);
                await mutateAsyncUpdate({
                    _id: id,
                    category_id: itemData.category_id,
                    // category_name: itemData.category_name,
                    category_name: {
                        el: itemData.category_name_el,
                        en: itemData.category_name_en,
                    },

                    // machine: itemData.machine,
                    categoryItems: itemData.categoryItems,
                    images: allImages,
                });
                console.log('RESPONSE UPDATE')
            } else {

                // Check and prepare images
                const preparedImages = checkImageFiles(fileInputs);

                const payload = {
                    category_name: {
                        el: itemData.category_name_el,
                        en: itemData.category_name_en,
                    },
                    ...itemData,
                    images: preparedImages,
                };

                console.log('RESPONSE POST')
                await mutateAsyncPost(payload);
            }

            // Request succeeded
            if (edit) {
                console.log('SUCCESSFULL EDIT');
            } else {
                console.log('SUCCESSFULL NEW');
            }
        } catch (error) {
            // Request failed
            console.error(error);
            if (edit) {
                console.log('FAILED EDIT POST')

            } else {
                console.log('FAILED NEW POST')
            }
            if (error.response && error.response.status === 500) {
                console.log('FAILED POST 500')
            }
        }
    };

    const editHandler = (category) => {
        console.log('editHandler');
        console.log(category);
        setId(category._id)
        setEdit(true);
        setValue('category_id', category.category_id);
        // setValue('machine', category.machine);
        if(category.category_name && typeof category.category_name === 'object') {
            Object.keys(category.category_name).forEach(lang => {
                setValue(`category_name_${lang}`, category.category_name[lang]);
            });
        }
        // setValue('categoryItems', category.categoryItems);
        console.log('images');

        console.log(category.images);
        setImageThumbnails(category.images)
        setImagesPath(data.images_path);
        setValue('images', category.images);

    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Categories</title>
                    <meta property='og:title' content='Categories' key='title'/>
                </Helmet>
            </HelmetProvider>
            {/*{isErrorPost && <Message variant='danger'>{errorPost}</Message>}*/}
            {/*{isErrorUpdate && <Message variant='danger'>{errorUpdate}</Message>}*/}

            {/*{isSuccessDelete && (*/}
            {/*    <Message variant='success'>Category has been deleted successfully.</Message>*/}
            {/*)}*/}
            {/*{isErrorDelete && <Message variant='danger'>{errorDelete}</Message>}*/}
            {/*{isSuccessUpdate && (*/}
            {/*    <Message variant='success'>Category has been updated successfully.</Message>*/}
            {/*)}*/}
            {/*{isSuccessPost && (*/}
            {/*    <Message variant='success'>Category has been Created successfully.</Message>*/}
            {/*)}*/}

            <div className='view-list-top-bar'>

                <h3 className='fw-light text-muted text-center mb-3'>
                    {t("Categories List")} <sup className='fs-6'> [{data && data.total}] </sup>
                    <img className="categories-list-title-icon admin-list-title-icon" src={DefaultCategoriesIcon}
                         alt="Default Marker Icon"/>
                </h3>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <button
                        className='btn add-new-entry-button align-self-end'
                        data-bs-toggle='modal'
                        data-bs-target='#categoryModal'
                        onClick={() => formCleanHandler(true)}
                    >
                        {t("Add New Category")}
                    </button>
                    <Pagination data={data} setPage={setPage}/>
                </div>

                <div className='col-auto full-search'>
                    <Search
                        placeholder={t("Search by Name")}
                        setQ={setQ}
                        q={q}
                        searchHandler={searchHandler}
                    />
                </div>
            </div>

            {isLoading ? (
                <Spinner />
            ) : isError ? (
                <Message variant="danger">
                    {error?.message || 'An unexpected error occurred.'}
                </Message>
            ) : (
                <ViewCategories
                    data={data}
                    editHandler={editHandler}
                    deleteHandler={deleteHandler}
                    isLoadingDelete={isLoadingDelete}
                    useTranslation={useTranslation}
                    // images_path={imagesPath}
                />
            )}
            <div className='pagination-bottom-block'>
                <Pagination data={data} setPage={setPage}/>
            </div>
            <FormCategories
                edit={edit}
                formCleanHandler={formCleanHandler}
                isLoading={isLoading}
                isError={isError}
                isErrorUpdate={isErrorUpdate}
                errors={errors}
                isLoadingUpdate={isLoadingUpdate}
                isLoadingPost={isLoadingPost}
                register={register}
                handleSubmit={handleSubmit}
                submitHandler={submitHandler}
                watch={watch}
                error={error}
                setValue={setValue}
                imageThumbnails={imageThumbnails}
                fileInputs={fileInputs}
                setFileInputs={setFileInputs}
                // dataMachines={dataMachines}
                images_path={imagesPath}
                useTranslation={useTranslation}

            />
        </>
    )
}


export default ProductCategories
